(function () {
  function pad(value) {
    return String(value).padStart(2, '0');
  }

  function initCountdowns() {
    document.querySelectorAll('[data-zbd-countdown]').forEach(function (countdown) {
      var hours = Number(countdown.getAttribute('data-hours') || 6);
      var storageKey = 'zbd-countdown-' + (countdown.getAttribute('data-key') || 'default');
      var endTime = Number(window.localStorage.getItem(storageKey));

      if (!endTime || endTime < Date.now()) {
        endTime = Date.now() + hours * 60 * 60 * 1000;
        window.localStorage.setItem(storageKey, String(endTime));
      }

      function render() {
        var remaining = Math.max(0, endTime - Date.now());
        var totalSeconds = Math.floor(remaining / 1000);
        var days = Math.floor(totalSeconds / 86400);
        var hoursLeft = Math.floor((totalSeconds % 86400) / 3600);
        var minutes = Math.floor((totalSeconds % 3600) / 60);
        var seconds = totalSeconds % 60;

        var map = {
          days: pad(days),
          hours: pad(hoursLeft),
          minutes: pad(minutes),
          seconds: pad(seconds)
        };

        Object.keys(map).forEach(function (key) {
          var target = countdown.querySelector('[data-zbd-time="' + key + '"]');
          if (target) target.textContent = map[key];
        });
      }

      render();
      window.setInterval(render, 1000);
    });
  }

  function initSavingsLabels() {
    var compare = document.querySelector('.price .price-item--regular');
    var sale = document.querySelector('.price .price-item--sale');
    var holder = document.querySelector('[data-zbd-product-savings]');
    if (!compare || !sale || !holder) return;

    var parseMoney = function (text) {
      var cleaned = text.replace(/[^0-9.,]/g, '').replace(',', '.');
      return Number(cleaned);
    };

    var compareValue = parseMoney(compare.textContent || '');
    var saleValue = parseMoney(sale.textContent || '');
    if (!compareValue || !saleValue || compareValue <= saleValue) return;

    var percent = Math.round(((compareValue - saleValue) / compareValue) * 100);
    holder.textContent = 'Ahorras ' + percent + '% hoy';
    holder.style.display = 'block';
  }

  function initStickyProductBar() {
    var submit = document.querySelector('.product-form__submit');
    if (!submit || document.querySelector('[data-zbd-sticky-atc-global]')) return;

    var productTitle = document.querySelector('.product__title h1');
    var price = document.querySelector('.price .price-item--sale') || document.querySelector('.price .price-item--regular');
    var bar = document.createElement('div');
    bar.className = 'zbd-sticky-atc';
    bar.setAttribute('data-zbd-sticky-atc-global', '');
    bar.innerHTML =
      '<div><strong>' + (productTitle ? productTitle.textContent.trim() : 'ZEBEDO') + '</strong>' +
      '<span>' + (price ? price.textContent.trim() : 'Listo para añadir') + '</span></div>' +
      '<button type="button" class="button zbd-dance">Añadir al carrito</button>';

    document.body.appendChild(bar);
    bar.querySelector('button').addEventListener('click', function () {
      submit.click();
    });

    function update() {
      var rect = submit.getBoundingClientRect();
      var shouldShow = rect.bottom < 0 || rect.top > window.innerHeight;
      bar.classList.toggle('is-visible', shouldShow);
    }

    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
  }

  function init() {
    initCountdowns();
    initSavingsLabels();
    initStickyProductBar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
